export const txConfig = {
  initialIssuerXLM: 1.5,
  createTrustXLM: 0.5,
  issueFee: 0.1,
  txFee: 0.1,
  offerEntryReserve: 0.5,
};